import { getDownloadURL, listAll, ref } from "firebase/storage";
import _ from 'lodash';
import { callFunction } from "./fbAll";
import { getAppConfigSettings } from "project/appConfiguration";
import { createRefPath } from "global/firestoreData/appData/appRefPaths";
import { fs_db } from "global/firestoreData/appData/fsAppData";
import { getDownloadedUrlFiles } from "global/storage/storageHelpers";
import { fbAppConfigs } from "project/appConfigs";

const storageGenericTypes = {
  storageGeneric: 'storageGeneric',
}

export const storageFunctionTypes = {
  // generateAllManifests: 'generateAllManifests',
  makeAllManifestsPublic: 'makeAllManifestsPublic',
  moveDirectToPages: 'moveDirectToPages',
  moveFolder_clientToClient: 'moveFolder_clientToClient',
  moveFolder_galleryDirectToClient: 'moveFolder_galleryDirectToClient',
  moveToGlobal: 'moveToGlobal ',
  renameStorageImages: 'renameStorageImages',
  syncEventImages: 'syncEventImages',
  testStorageFile: 'testStorageFile',
  transferAllStorageFolder: 'transferAllStorageFolder',
  transferClientProfilesStorage: 'transferClientProfilesStorage',
  transferEventStorage: 'transferEventStorage',
  updateImageThumbnails: 'updateImageThumbnails',
}

const callFsFunction = async (fsCall, callData) => {
  const data = await fsCall(storageGenericTypes.storageGeneric, callData)
  return data
}

export const fsfn_storage = (fsCall) => ({
  updateImageThumbnails: (pathViews, callback, image_path) => fsfn_updateImageThumbnails(fsCall, pathViews, callback, image_path),
  renameStorageImages: (pathViews, callback, testOnly, urlsOnly) => fsfn_renameStorageImages(fsCall, pathViews, callback, testOnly, urlsOnly),
  moveDirectToPages: (pathViews, callback) => fsfn_moveToNewFolder(fsCall, pathViews, callback),
  moveToGlobal: (pathViews, callback) => fsfn_organizeEventImages(fsCall, pathViews, callback),
  // generateAllManifests: (database_fns, mainStorage, projectIds, callback) => generateAllManifests(fsCall, database_fns, mainStorage, projectIds, callback),
  makeAllManifestsPublic: (projectIds, bucketFolder, callback) => makeAllManifestsPublic(fsCall, projectIds, bucketFolder, callback),
  moveAttendeeFolders: (fss, pvKeys, transfers, showLogs, callback, fileName) => fsfn_moveAttendeeFolders(fsCall, mainStorage, fss, pvKeys, transfers, showLogs, callback, fileName),
  moveStorageFiles: (mainStorage, data) => moveStorageFiles(fsCall, mainStorage, data),
  syncEventImages: (pathViews, callback) => fsfn_syncEventImages(fsCall, pathViews, callback),
  transferAllStorageFolder: (projectIds, pvKeys, callback, testOnly) => transferAllStorageFolder(fsCall, projectIds, pvKeys, callback, testOnly),
})


const getAllEvents = async (database_fns, clients) => {
  const promises = []
  if (clients) {
    _.forEach(clients, async (client, clientKey) => {
      const refPath_events = createRefPath(['clients', clientKey, 'events'])
      promises.push(
        database_fns.get_data({ refPath: refPath_events }).then((events) => ({
          clientKey,
          events
        }))
      );
    })
  }
  return Promise.all(promises)
}

const getAllSettingsData = async (database_fns, clients, events_combined) => {
  const promises = []

  _.forEach(clients, async (client, clientKey) => {
    const refPath_settings = createRefPath(['settings', clientKey, 'settings', 'global'])
    promises.push(
      database_fns.get_data({ refPath: refPath_settings, opts: { returnFirstObject: true, ignoreId: true } }).then((settings) => ({
        clientKey,
        settings
      }))
    );
    // promises.push(database_fns.get_data({ refPath: refPath_settings, opts: { returnFirstObject: true, ignoreId: true } }))
  })

  _.forEach(events_combined, async (event, eventKey) => {
    const refPath_settings = createRefPath(['settings', eventKey, 'settings', 'global'])
    promises.push(
      database_fns.get_data({ refPath: refPath_settings, opts: { returnFirstObject: true, ignoreId: true } }).then((settings) => ({
        clientKey: event?.clientKey,
        eventKey,
        settings
      }))
    );
    // promises.push(database_fns.get_data({ refPath: refPath_settings, opts: { returnFirstObject: true, ignoreId: true } }))
  })
  return Promise.all(promises)
}

const getAllSettingsDataManifests = async (settingsData) => {

  const settings_manifests = {}
  _.forEach(settingsData, (settingsDataItem, sdiKey) => {
    const { settings, eventKey, clientKey } = settingsDataItem ?? {}
    if (settings) {
      const { manifest, themeColors } = settings ?? {}
      const { colors } = manifest ?? {}
      const { backgroundColor } = colors ?? {}
      const _color = themeColors?.[backgroundColor] ? themeColors[backgroundColor] : 'black'
      const _manifest = {
        ...manifest,
        background_color: _color,
        theme_color: _color,
        display: 'standalone',
        orientation: 'portrait-primary',
        id: manifest?.name || 'app-id',
      }
      if (clientKey) {
        _manifest.clientKey = clientKey
      }
      if (eventKey) {
        _manifest.eventKey = eventKey
      }
      delete _manifest.colors
      delete _manifest.appleStartUpImage
      delete _manifest.appleTouchIcon72
      delete _manifest.appleTouchIcon120
      delete _manifest.appleTouchIcon152
      const _settingsKey = eventKey ? eventKey : clientKey
      settings_manifests[_settingsKey] = _manifest || {}
    }
  })
  return settings_manifests
}

// JANUARY50
const fsfn_updateImageThumbnails = async (fsCall, pathViews, callback, image_path) => {

  const appKeys = {
    dev: fbAppConfigs.meetingevolution.dev.projectId,
    prod: fbAppConfigs.meetingevolution.prod.projectId,
  }

  try {
    const appConfigSettings = getAppConfigSettings()
    const { isDev_me, isLocalhost } = appConfigSettings

    const projectIds = {
      source: (isDev_me || isLocalhost) ? appKeys.dev : appKeys.prod
    }

    const callData = {
      pathViews,
      projectIds,
      basePath: `clients/${pathViews.clients}/profiles`,
      storageFunctionType: storageFunctionTypes.updateImageThumbnails,
      forceThumbnail: true,
      showLogs: true,
      folderName: image_path
    }

    console.log('callData', callData)
    const response_data = await callFsFunction(fsCall, callData) // OK  
    console.log('response_data', response_data)
    // each item contains a _gsid, which is the key of the data item

    const { success, result } = response_data ?? {}

    if (success && trueResult) {
      const ret = { success, result: trueResult }
      callback(ret)
    } else {
      const ret = { success: false, result: {} }
      callback(ret)
    }
  } catch (error) {
    callback({ success: false })
  }
}

const fsfn_renameStorageImages = async (fsCall, pathViews, callback, testOnly, urlsOnly) => {

  const appKeys = {
    dev: fbAppConfigs.meetingevolution.dev.projectId,
    prod: fbAppConfigs.meetingevolution.prod.projectId,
  }

  try {
    const appConfigSettings = getAppConfigSettings()
    const { isDev_me, isLocalhost } = appConfigSettings

    // i@mfgtgmsti2025!

    const projectIds = {
      source: (isDev_me || isLocalhost) ? appKeys.dev : appKeys.prod
    }

    const callData = {
      pathViews,
      projectIds,
      basePath: `clients/${pathViews.clients}/profiles`,
      storageFunctionType: storageFunctionTypes.renameStorageImages,
      commit: testOnly ? false : true,
      urlsOnly: urlsOnly,
      deleteOriginal: true,
      showLogs: true
    }

    console.log('callData', callData)
    const response_data = await callFsFunction(fsCall, callData) // OK  
    console.log('response_data', response_data)
    // each item contains a _gsid, which is the key of the data item

    const { success, result } = response_data ?? {}

    if (success && trueResult) {
      const ret = { success, result: trueResult }
      callback(ret)
    } else {
      const ret = { success: false, result: {} }
      callback(ret)
    }
  } catch (error) {
    callback({ success: false })
  }
}

const fsfn_moveToNewFolder = async (fsCall, pathViews, callback) => {

  const appKeys = {
    dev: fbAppConfigs.meetingevolution.dev.projectId,
    prod: fbAppConfigs.meetingevolution.prod.projectId,
  }

  try {
    const appConfigSettings = getAppConfigSettings()
    const { isDev_me, isLocalhost } = appConfigSettings

    const projectIds = {
      source: (isDev_me || isLocalhost) ? appKeys.dev : appKeys.prod
    }

    const callData = {
      pathViews,
      projectIds,
      storageFunctionType: storageFunctionTypes.moveDirectToPages,
      deleteExisting: false,
      oldFolder: '_gallery_direct',
      newFolder: 'pages',
      modifyFileNames: true
    }

    console.log('callData', callData)
    const response_data = await callFsFunction(fsCall, callData) // OK  
    // each item contains a _gsid, which is the key of the data item

    const { success, result } = response_data ?? {}
    const { result: trueResult } = result ?? {}

    if (success && trueResult) {
      const ret = { success, result: trueResult }
      callback(ret)
    } else {
      const ret = { success: false, result: {} }
      callback(ret)
    }
  } catch (error) {
    callback({ success: false })
  }
}

const fsfn_organizeEventImages = async (fsCall, pathViews, callback) => {

  const appKeys = {
    dev: fbAppConfigs.meetingevolution.dev.projectId,
    prod: fbAppConfigs.meetingevolution.prod.projectId,
  }

  try {
    const appConfigSettings = getAppConfigSettings()
    const { isDev_me, isLocalhost } = appConfigSettings

    const projectIds = {
      source: (isDev_me || isLocalhost) ? appKeys.dev : appKeys.prod
    }

    const callData1 = {
      pathViews,
      projectIds,
      storageFunctionType: storageFunctionTypes.moveToGlobal,
      deleteExisting: false,
      folders: ['image', 'icon', 'floormap'],
      folderBase: 'global'
    }

    const response_data_1 = await callFsFunction(fsCall, callData1) // OK   
    // each item contains a _gsid, which is the key of the data item

    const { success, result } = response_data_1 ?? {}
    const { result: trueResult } = result ?? {}

    if (success && trueResult) {
      const ret = { success, result: trueResult }
      callback(ret)
    } else {
      const ret = { success: false, result: {} }
      callback(ret)
    }
  } catch (error) {
    callback({ success: false })
  }
}

const fsfn_syncEventImages = async (fsCall, pathViews, callback) => {

  const appKeys = {
    dev: fbAppConfigs.meetingevolution.dev.projectId,
    prod: fbAppConfigs.meetingevolution.prod.projectId,
  }

  try {
    const appConfigSettings = getAppConfigSettings()
    const { isDev_me, isLocalhost } = appConfigSettings

    const projectIds = {
      source: (isDev_me || isLocalhost) ? appKeys.dev : appKeys.prod
    }

    const callData = {
      pathViews,
      projectIds,
      storageFunctionType: storageFunctionTypes.syncEventImages,
      clearPrior: true,
      useGlobal: false,
      usePages: false,
      parentFolders: ['global', 'pages']
    }

    const response_data = await callFsFunction(fsCall, callData) // OK  
    // each item contains a _gsid, which is the key of the data item 
    const { success, result } = response_data ?? {}
    const { result: trueResult } = result ?? {}



    if (success && trueResult) {
      const ret = { success, result: trueResult }
      callback(ret)
    } else {
      const ret = { success: false, result: {} }
      callback(ret)
    }
  } catch (error) {
    callback({ success: false })
  }
}

const makeAllManifestsPublic = async (fsCall, projectIds, buckFmovetFolder, callback) => {

  try {
    const callData = {
      storageFunctionType: storageFunctionTypes.makeAllManifestsPublic,
      projectIds,
      bucketFolder
    }

    const response_data = await callFsFunction(fsCall, callData) // OK  
    // each item contains a _gsid, which is the key of the data item

    const { success, result } = response_data
    const { result: trueResult } = result ?? {}

    if (success && trueResult) {
      const ret = { success, result: trueResult }
      callback(ret)
    } else {
      const ret = { success: false, result: {} }
      callback(ret)
    }
  } catch (error) {
    callback({ success: false })
  }
}

const transferAllStorageFolder = async (fsCall, projectIds, pvKeys, callback, testOnly) => {

  try {
    const callData = {
      storageFunctionType: storageFunctionTypes.transferAllStorageFolder,
      projectIds,
      pvKeys,
      testOnly
    }

    const response_data = await callFsFunction(fsCall, callData) // OK  
    // each item contains a _gsid, which is the key of the data item

    const { success, result } = response_data
    const { result: trueResult } = result ?? {}

    if (success && trueResult) {
      const ret = { success, result: trueResult }
      callback(ret)
    } else {
      const ret = { success: false, result: {} }
      callback(ret)
    }
  } catch (error) {
    callback({ success: false })
  }
}

/**
 * Gets the data from a googleSheet using the firebase function `getSheets`
 * @param {object} sheetProps 
 * @param {string} appArea 
 * @param {object} googleSheetsImportOptions 
 * @param {object} logging 
 * @returns data
 */
const fsfn_moveAttendeeFolders = async (fsCall, fss, pvKeys, transfers, showLogs, callback, fileName) => {

  const projectPaths = {
    source: pvKeys && pvKeys.source.events ? 'clients/' + pvKeys.source.clients + '/events/' + pvKeys.source.events : 'clients/' + pvKeys.source.clients,
    destination: pvKeys && pvKeys.destination.events ? 'clients/' + pvKeys.destination.clients + '/events/' + pvKeys.destination.events : 'clients/' + pvKeys.source.clients,
  }

  const projectIds = {
    source: fss && fss.source && fss.source._databaseId && fss.source._databaseId.projectId ? fss.source._databaseId.projectId : null,
    destination: fss && fss.destination && fss.destination._databaseId && fss.destination._databaseId.projectId ? fss.destination._databaseId.projectId : null
  }

  const folderNames = {
    source: 'attendees',
    destination: 'profiles',
  }

  try {
    const callData = {
      storageFunctionType: storageFunctionTypes.transferClientProfilesStorage,
      transfers,
      projectIds,
      projectPaths,
      folderNames,
      showLogs,
      fileName,
      transferData: true,
      ignoreExisting: false
    }

    const response_data = await callFsFunction(fsCall, callData) // OK  
    // console.log('rd', response_data)
    // each item contains a _gsid, which is the key of the data item

    const { success, result } = response_data
    const { result: trueResult } = result ?? {}

    if (success && trueResult) {
      const ret = { success, result: trueResult }
      callback(ret)
    } else {
      const ret = { success: false, result: {} }
      callback(ret)
    }
  } catch (error) {
    callback({ success: false })
  }
}

/**
 * Gets the data from a googleSheet using the firebase function `getSheets`
 * @param {object} sheetProps 
 * @param {string} appArea 
 * @param {object} googleSheetsImportOptions 
 * @param {object} logging 
 * @returns data
 */
const fsfn_transferStorage = async (fss, pvKeys, transfers, callback, viewItemKey, fileName, formData) => {

  const projectPaths = {
    source: pvKeys && pvKeys.source.events ? 'clients/' + pvKeys.source.clients + '/events/' + pvKeys.source.events : 'clients/' + pvKeys.source.clients,
    destination: pvKeys && pvKeys.destination.events ? 'clients/' + pvKeys.destination.clients + '/events/' + pvKeys.destination.events : 'clients/' + pvKeys.source.clients,
  }

  const projectIds = {
    source: fss && fss.source && fss.source._databaseId && fss.source._databaseId.projectId ? fss.source._databaseId.projectId : null,
    destination: fss && fss.destination && fss.destination._databaseId && fss.destination._databaseId.projectId ? fss.destination._databaseId.projectId : null
  }

  try {
    const callData = {
      transfers,
      projectIds,
      projectPaths,
      pvKeys,
      showLogs: true,
      fileName,
      transferData: true,
      ignoreExisting: false
    }

    if (transfers.eventStorage) {
      callData.storageFunctionType = storageFunctionTypes.transferEventStorage
    } else if (transfers.clientProfileStorage) {
      callData.storageFunctionType = storageFunctionTypes.transferClientProfilesStorage
      callData.folderNames = { source: 'attendees', destination: 'profiles' }
    } else if (transfers.eventFolderToClient && viewItemKey) {
      callData.storageFunctionType = storageFunctionTypes.moveFolder_galleryDirectToClient
      callData.folderNames = { source: viewItemKey, destination: viewItemKey }
    } else if (transfers.clientToClient && formData && formData.eventKey) {
      callData.storageFunctionType = storageFunctionTypes.moveFolder_clientToClient
      callData.folderNames = { source: formData.eventKey, destination: formData.eventKey }
    } else if (transfers.clientProfilesToClientProfiles && formData && formData.eventKey) {
      callData.storageFunctionType = storageFunctionTypes.moveFolder_clientToClient
      callData.folderNames = { source: 'profiles', destination: 'profiles' }
    }

    let response_data = {};

    if (callData.storageFunctionType) {
      response_data = await callFsFunction(fsCall, callData) // OK  
    }

    const { success, result } = response_data ?? {}
    const { result: trueResult } = result ?? {}

    if (success && trueResult) {
      const ret = { success, result: trueResult }
      callback(ret)
    } else {
      const ret = { success: false, result: {} }
      callback(ret)
    }
  } catch (error) {
    callback({ success: false })
  }
}

function hasDownloadUrl(files, obj) {
  if (_.has(obj, 'downloadURL')) {
    return true;
  }

  for (const key in obj) {
    if (_.isObject(obj[key])) {
      if (hasDownloadUrl(files, obj[key])) {
        files.push(obj[key].downloadURL)
        return true;
      }
    }
  }

  return false;
}

const moveStorageFiles = async (fsCall, mainStorage, data) => {

  // @ts-ignore
  const { projectPaths } = data ?? {}
  const { source: sourceFolderPath } = projectPaths ?? {}

  const folderRef = ref(mainStorage, sourceFolderPath);
  const sis = await fetchStorageItems(folderRef)
  console.log('sis', sis)

  const files = []
  hasDownloadUrl(files, sis)
  console.log('files', files)

}

const fetchStorageItems = async (folderRef) => {

  const items = [];

  const { prefixes, items: files } = await listAll(folderRef);

  for (const fileRef of files) {
    const downloadURL = await getDownloadURL(fileRef);
    items.push({ type: 'file', downloadURL });
  }

  for (const prefixRef of prefixes) {
    const subItems = await fetchStorageItems(prefixRef);
    items.push({ type: 'folder', name: prefixRef.name, subItems });
  }

  return items;
};

